const ID = 'toggle';

export default ID;
